import React from 'react';
import { Button, Drawer, Tooltip, Typography } from 'antd';
import { YoutubeOutlined } from '@ant-design/icons';
var {
  Link,
  Paragraph,
  Text,
  Title
} = Typography;
export default function DocsQueryBuilder(_ref) {
  var {
    drawerVisible,
    closeDrawer
  } = _ref;
  return /*#__PURE__*/React.createElement(Drawer, {
    title: "Integrated Examples",
    placement: "right",
    closable: true,
    onClose: closeDrawer,
    visible: drawerVisible
  }, /*#__PURE__*/React.createElement(Paragraph, null, "Our ", /*#__PURE__*/React.createElement(Text, {
    code: true
  }, " API Console Query Builder"), " helps users generate custom formulas, test different queries and try template samples for easy report creation."), /*#__PURE__*/React.createElement(Paragraph, null, "Integrated examples are a tool we provide that can be dropped into your existing reports or used for prototyping."), /*#__PURE__*/React.createElement(Title, {
    level: 4
  }, "To learn more, see these tutorials"), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "View tutorial on Youtube"
  }, /*#__PURE__*/React.createElement(Link, {
    href: "https://youtu.be/rtby2ffmcYU",
    target: "_blank"
  }, "Excel"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "View tutorial on Youtube"
  }, /*#__PURE__*/React.createElement(Link, {
    href: "https://youtu.be/TkpHl9w2gbY",
    target: "_blank"
  }, "Google Sheets"))))), /*#__PURE__*/React.createElement(Title, {
    level: 4
  }, "Additional Resources"), /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://intercom.help/cryptosheets/en/articles/3472916-using-the-cryptosheets-api-console-query-and-function-formula-builder-for-excel-googlesheets",
    target: "_blank"
  }, "Help Center")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://intercom.help/cryptosheets/en/?q=api+console",
    target: "_blank"
  }, "Related Articles")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://docs.cryptosheets.com/cryptosheets-concepts/api-console/",
    target: "_blank"
  }, "API Console Formula Builder")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    href: "https://docs.cryptosheets.com/cryptosheets-concepts/graphql/",
    target: "_blank"
  }, "GraphQL API Console Formula Builder")))));
}